import React from 'react';

function LeaderboardContainer({ children }) {
  return (
    <div className='si-main__ct si-leaderborad'>
      <div className='si-container'>
        <section className='si-wrap'>
          <section className='si-main si-main--lb'>{children}</section>
        </section>
      </div>
    </div>
  );
}

export default LeaderboardContainer;
